import { DocumentData, FirestoreDataConverter } from 'firebase/firestore'

export class Subcontractor {
  id: string
  accountId: string
  name: string
  phone: string
  email: string
  address: string
  isCompany: boolean
  companyId: string
  trade: string
  createdAt: Date
  updatedAt: Date

  constructor () {
    this.name = ''
    this.email = ''
    this.phone = ''
    this.address = ''
    this.trade = ''
    this.isCompany = false
    this.createdAt = new Date()
    this.updatedAt = new Date()
  }
}

export const subcontractorConverter: FirestoreDataConverter<Subcontractor, DocumentData> = {
  toFirestore(subcontractor: Subcontractor) {
    subcontractor.createdAt = subcontractor.createdAt ? new Date(subcontractor.createdAt) : new Date()
    subcontractor.updatedAt = new Date()

    return Object.assign({}, subcontractor)
  },

  fromFirestore(snapshot, options) {
    const data = snapshot.data(options)
    data.createdAt = (typeof data.createdAt === 'object') ? data.createdAt.toDate() : data.createdAt
    data.updatedAt = (typeof data.updatedAt === 'object') ? data.updatedAt.toDate() : data.updatedAt

    return Object.assign(new Subcontractor(), data)
  }
}
